import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ListItem, ListItemText, Icon, ListItemSecondaryAction, Collapse, List, ListItemIcon, IconButton, ListSubheader } from "@material-ui/core";
import ConfirmDeleteCategory from './ConfirmDeleteCategory';
import MoreOptionsMenu from './MoreOptionsMenu';
import { chooseCategory } from '../../redux/actions/categoryActions';

class CategoryItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showingSubcategories: false,
            showDeleteModal: false,
            moreButton: null,
            selectedCategory: null
        };

        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.showDeleteModal = this.showDeleteModal.bind(this);
        this.hideDeleteModal = this.hideDeleteModal.bind(this);
        this.showMoreOptions = this.showMoreOptions.bind(this);
        this.closeMoreOptions = this.closeMoreOptions.bind(this);
    }

    toggleCollapse() {
        this.setState({
            showingSubcategories: !this.state.showingSubcategories
        });
    }

    showDeleteModal() {
        this.setState({
            showDeleteModal: true
        });
    }

    hideDeleteModal() {
        this.setState({
            showDeleteModal: false
        });
        this.closeMoreOptions();
    }

    showMoreOptions(evt, category) {
        this.setState({
            moreButton: evt.currentTarget,
            selectedCategory: category
        });
    }

    closeMoreOptions() {
        this.setState({
            moreButton: null,
            selectedCategory: null
        });
    }

    render() {
        const { showingSubcategories } = this.state;
        const { category, subcategories } = this.props;
        const hasSubcategories = subcategories.length > 0;
        return (
            <div>
                <ListItem onClick={hasSubcategories ? this.toggleCollapse : () => { }} button>
                    <ListItemIcon>
                        <Icon>category</Icon>
                    </ListItemIcon>
                    <ListItemText
                        primary={category.name}
                    />

                    {
                        hasSubcategories ?
                            <Icon>{showingSubcategories ? "arrow_drop_up" : "arrow_drop_down"}</Icon>
                            :
                            null
                    }

                    <ListItemSecondaryAction>
                        <IconButton edge="end"
                            aria-label="Delete"
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            data-id={2}
                            onClick={(evt) => {
                                this.showMoreOptions(evt, category);
                            }}>
                            <Icon>more_vert</Icon>
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                {
                    hasSubcategories ?
                        <Collapse in={this.state.showingSubcategories} timeout="auto" unmountOnExit>
                            <List subheader={
                                <ListSubheader component="div" id="nested-list-subheader">
                                    Subcategories
                                </ListSubheader>
                            } component="div" style={{ paddingRight: 50, paddingLeft: 50 }}>
                                {
                                    subcategories.map((subcategory, i) => {
                                        return (
                                            <ListItem key={i} button>
                                                <ListItemText primary={subcategory.name} />
                                                <ListItemSecondaryAction>
                                                    <IconButton edge="end"
                                                        aria-controls="simple-menu"
                                                        aria-haspopup="true"
                                                        data-id={2}
                                                        onClick={(evt) => {
                                                            this.showMoreOptions(evt, subcategory);
                                                        }}>
                                                        <Icon>more_vert</Icon>
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        );
                                    })
                                }

                            </List>
                        </Collapse>
                        :
                        null
                }

                <MoreOptionsMenu menuAnchor={this.state.moreButton}
                    closeMenu={this.closeMoreOptions}
                    deleteCategory={this.showDeleteModal}
                    editCategory={() => {
                        this.props.chooseCategory(this.state.selectedCategory);
                        this.props.editCategory(this.state.selectedCategory);
                    }} />

                <ConfirmDeleteCategory showConfirm={this.state.showDeleteModal}
                    category={this.state.selectedCategory}
                    onClose={this.hideDeleteModal} />
            </div>
        );
    }
}


const mapDispatchToProps = dispatch => (
    bindActionCreators({ chooseCategory }, dispatch)
);

export default connect(null, mapDispatchToProps)(CategoryItem);